<template>
	<link-dialog v-bind="option" v-model="p_value" @confirm="pl_confirm" @cancel="pl_cancel">
		<div class="link-dialog-service-edit-wrapper" v-if="option.editType != null">
			<link-input v-model="option.editValue" v-if="option.editType === 'input'" :readonly="option.editReadonly === true" ref="input" @enter="pl_confirm"/>
			<link-input-number v-model="option.editValue" v-if="option.editType === 'number'" :readonly="option.editReadonly === true" ref="input" @enter="pl_confirm"/>
			<link-textarea v-model="option.editValue" v-if="option.editType === 'textarea'" :readonly="option.editReadonly === true" :maxlength="option.maxlength" show-word-limit="option.showWordLimit" ref="input"/>
		</div>
		<lv-render-func v-else-if="!!option.render" :render-func="option.render"/>
		<span v-else>{{option.message}}</span>
		<lv-render-func v-if="!!option.footLeftRender" :render-func="option.footLeftRender" slot="footLeft"/>
	</link-dialog>
</template>

<script>
    import LinkDialog from "./link-dialog";
    import LvRenderFunc from "../render/lv-render-func";
    import LinkInput from "../input/link-input";
    import LinkTextarea from "../textarea/link-textarea";

    export default {
        name: "link-dialog-service",
        components: {LinkTextarea, LinkInput, LvRenderFunc, LinkDialog},
        data() {
            const defaultOption = {
                type: 'info',
                title: LinkVue.$t('LinkForm.tips'),
                shape: 'none',
                shadowColor: 'rgba(0,0,0,0.25)',
                disabledHideOnClickShadow: true,
                transition: 'link-dialog-animate-drop',
                height: null,
                minHeight: null,
                maxHeight: '600px',
                width: null,
                minWidth: null,
                maxWidth: null,
                full: false,
                confirmButton: false,
                cancelButton: false,
                confirmButtonText: LinkVue.$t('global.confirm'),
                cancelButtonText: LinkVue.$t('global.cancel'),
                noClose: false,
                dialogClass: null,
                vertical: 'center',
                horizontal: null,
                initialized: true,
                destroyOnHide: false,
                transferDom: false,
                max: false,
                noHeader: false,
                noFooter: false,
                noPadding: false,
                top: null,
                bottom: 0,
                left: 0,
                right: 0,
                footAlign: 'center',
                zIndex: 9999,
                stable: false,

                onConfirm: null,
                onCancel: null,
                render: null,
                footLeftRender: null,

                editValue: null,
                editType: null,             //input|textarea
                editReadonly: null,
            }
            return {
                p_value: false,
                defaultOption,
                option: this.$lv.$utils.deepCopy(defaultOption)
            }
        },
        methods: {
            show(message, option) {
                let opt = option || {};
                const firstArgType = this.$lv.$utils.typeOf(message)
                switch (firstArgType) {
                    case 'string':
                        opt.message = message
                        break;
                    case 'object':
                        opt = message
                        break
                }
                if (!!opt.render && opt.zIndex == null) opt.zIndex = 0
                Object.assign(this.option, this.defaultOption, opt)
                this.p_value = true

                if (!!this.option.editType && !this.option.editReadonly) {
                    this.$nextTick(() => {
                        let target;
                        switch (this.option.editType) {
                            case "input":
                                target = this.$refs.input.$refs.input
                                break
                            case "textarea":
                                target = this.$refs.input.$refs.textarea
                                break
                            case "number":
                                target = this.$refs.input.$refs.input.$refs.input
                        }
                        if (!!target) {
                            target.focus()
                            target.select()
                        }
                    })
                }

                return this
            },
            hide() {
                this.p_value = false
            },
            pl_confirm() {
                let param = this.option.editType != null ? this.option.editValue : null
                !!this.option.onConfirm && this.option.onConfirm(param)
                this.hide()
            },
            pl_cancel() {
                !!this.option.onCancel && this.option.onCancel()
                this.hide()
            },
        },
    }
</script>

<style lang="scss">
	.link-dialog-service-edit-wrapper {
		.link-input {
			width: 100% !important;
		}

		.link-textarea {
			width: 450px !important;
			height: 300px !important;
		}
	}

	@include themeify {
		.link-dialog-message-service {
			.link-dialog-content {
				border-radius: 8px !important;
				box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.16) !important;
				padding: 16px;

				.link-dialog-message-service {
					display: flex;

					& > .link-icon {
						font-size: 36px;
						color: pl-var(color-error);
						margin-right: 16px;
					}

					& > div {
						flex: 1;
						display: flex;
						flex-direction: column;
						align-items: stretch;
						padding-top: 0.5em;

						.link-dialog-message-service-title {
							margin-bottom: 1em;
						}

						.link-dialog-message-service-content {
							margin-bottom: 1em;
							font-size: 14px;
							color: rgba(0, 0, 0, 0.65);
							letter-spacing: 0;
							text-align: left;
							line-height: 21px;
							max-height: 50vh;
							width: 100%;
							overflow: auto;
							word-break: break-word;
						}

						.link-dialog-message-service-button {
							.link-button {
								float: right;
								margin-left: 8px;
							}
						}
					}
				}
			}
		}
	}
</style>
